import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { CalculatorDocumentation } from "../../types/calculator-library"

const reducerPath = "calculatorLibrary"

/**
 * The calculator embed catalog is served by the RateComparison app, not the
 * BankingBridge API — a different origin, no auth, no session. So this slice
 * uses its own `fetchBaseQuery` rather than the shared `baseQuery`, which
 * attaches the session header and points at REACT_APP_API_HOST.
 */
export const calculatorLibraryApi = createApi({
  reducerPath,
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CALCULATOR_EMBED_HOST ?? ""
  }),
  endpoints: builder => ({
    fetchCalculatorCatalog: builder.query<CalculatorDocumentation[], void>({
      query: () => "/api/embed/calculators"
    })
  })
})

export const { useFetchCalculatorCatalogQuery } = calculatorLibraryApi
